import { getDeviceById, getGroupOfDevice, getRoomById } from "src/components/Planner/planner/uDev";
import { getProductOfDevice } from "src/components/Planner/planner/uDev-dom";
import { PlannerGlobals } from 'src/components/Planner/planner/planner-globals';
import { floorProvider } from 'src/components/Planner/planner/FloorProvider';
import { DeviceItem, UserCustomItems } from "src/model/api/v2/data-contracts";

export interface SourceDeviceInfo {
    device: any;
    productId: string;
    productName: string;
    image: string | null;
    roomName: string;
    floorName: string;
    isInGroup: boolean;
    isCustom: boolean;
}

export function getSourceDeviceInfo(deviceId: number): SourceDeviceInfo {
    const device = getDeviceById(deviceId);

    const product: DeviceItem | UserCustomItems | string | null = getProductOfDevice(device);
    const room = getRoomById(device.roomId);
    const isInGroup: boolean = getGroupOfDevice(deviceId) != null;
    const isCustom: boolean = device.user_custom_item_id != null;

    const productId = isCustom
        ? `user_custom_item_${device.user_custom_item_id}`
        : `product_${device.product_name_id}`;

    const productName = isCustom
        ? (product as UserCustomItems).product_name
        : (product as DeviceItem).text ?? 'Unknown';

    return {
        device,
        productId,
        productName,
        image: device.image ?? null,
        roomName: room?.roomname ?? 'Unknown',
        floorName: floorProvider.getFloorName(PlannerGlobals.plannerFloorId as unknown as number),
        isInGroup,
        isCustom,
    };
}